import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "app-overlay",
  class: "p-dialog-mask pointer-events-auto"
}

import { useRootStore } from '@/store';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'LoadingSpinner.vue3',
  setup(__props) {

const rootStore = useRootStore();
const isLoading = computed(() => rootStore.getters.isLoading);

return (_ctx: any,_cache: any) => {
  const _component_p_progress_spinner = _resolveComponent("p-progress-spinner")!

  return (isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (isLoading.value)
          ? (_openBlock(), _createBlock(_component_p_progress_spinner, {
              key: 0,
              "stroke-width": "4"
            }))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})